import React from 'react';
import { AuthContextType } from './types';

export const AuthContext = React.createContext<AuthContextType | undefined>(
  undefined,
);
